import { getCompressedFilesUrls, getFileUrl } from '@/api/file.api';
import { queryKeys } from '@/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetFileUrl = (
  key: string | null,
  original = false,
  accessToken?: string,
) =>
  useQuery({
    queryKey: queryKeys.file.byKey(key ?? '', original, accessToken),
    queryFn: () => getFileUrl(key, original, accessToken),
    staleTime: Infinity,
  });

export const useGetCompressedFilesUrls = (
  keys: string[],
  accessToken?: string,
) =>
  useQuery({
    queryKey: queryKeys.compressedFiles({ ...keys, accessToken }),
    queryFn: () => getCompressedFilesUrls(keys, accessToken),
    staleTime: Infinity,
  });
